import {of as observableOf,  Observable, Subject } from 'rxjs';

import {tap, map, switchMap} from 'rxjs/operators';
import { JhiAlertService } from 'ng-jhipster';
import { FileLikeObject, FileUploaderOptions, ParsedResponseHeaders } from 'ng2-file-upload';

import { EventEmitter, Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { DraftRequete, DraftRequeteSummary, Juridiction, Justificatifs, RequeteContentieuxSocial
} from '../entities/draft-requete/draft-requete.model';
import { GenericPiece, PieceActeAttaque, PieceComplementaire, PieceComplementaireOrigineType,
    PieceJointType, PiecePostale, PieceReclamationPrealable, PieceRequete
} from '../entities/piece-jointe';
import { PartieDepot, QualityType, RequeteCategory } from '../entities/requete';
import { TypeActeAttaque } from '../entities/type-acte-attaque';
import { TypeJuridiction } from '../entities/type-juridiction';
import { AccountType } from '../shared';
import { DraftModalComponent } from '../shared/components/draft-modal/draft-modal.component';
import { FileUploaderModel } from '../shared/components/file-uploader/file-uploader.model';
import { HEADER_DRAFT_VERSION } from '../shared/constants/application.constants';
import { ErrorEnum } from '../shared/constants/error.constants';
import { HttpCodeEnum } from '../shared/constants/http-code.constants';
import { TrackingAction, TrackingCategory } from '../shared/model/tracking/tracking.enum';
import { TrackingName } from '../shared/model/tracking/tracking.model';
import { DraftRequeteService } from '../shared/services/draft-requete.service';
import { ParametersService } from '../shared/services/parameters.service';
import { TrackingService } from '../shared/services/tracking.service';
import { DepotRequeteState } from './depot-requete-state.model';
import { DatePipe } from '@angular/common';
import { UrgenceRequete } from '../entities/urgence-requete';


@Injectable()
export class DraftDepotRequeteService {
    depotRequeteState: DepotRequeteState;
    juridictions: Array<TypeJuridiction>;
    typeActeAttaques: Array<TypeActeAttaque>;
    _eventDraftDeleted = new EventEmitter<any>();
    private dataSource = new Subject<any>();
    data$ = this.dataSource.asObservable();
    constructor(
        private draftRequeteService: DraftRequeteService,
        private router: Router,
        private alertService: JhiAlertService,
        private trackingService: TrackingService,
        private parametersService: ParametersService,
        private modalService: NgbModal,
        private datePipe: DatePipe
    ) {}

    get eventDraftDeleted(): EventEmitter<any> {
        return this._eventDraftDeleted;
    }

    sendData(data: any) {
        this.dataSource.next(data);
    }

    getAutoSaveTime(): any {
        let autoSaveTime = this.datePipe.transform(new Date(), 'H:mm')!;
        autoSaveTime =  autoSaveTime.replace(':', 'h');
        return autoSaveTime;
    }

    // convert creation date from format 'yyyy-MM-DDTHH:mm:ss' to ['DD/MM/yyyy', 'HHhmm']
    convertCreationDateToDateAndHour(creationDate: string): string[] {
        let dateAndHour: string[] = [];
        let date = creationDate.substring(0, creationDate.indexOf('T'));
        date = date.split('-').reverse().join('/');
        dateAndHour.push(date);
        let hour = creationDate.substring(creationDate.indexOf('T') + 1, creationDate.lastIndexOf(':'));
        hour = hour.split(':').join('h');
        dateAndHour.push(hour);
        return dateAndHour;
    }

    getDepotRequeteStateVersion(): any {
        if (this.depotRequeteState && this.depotRequeteState.version !== undefined) {
            return this.depotRequeteState.version;
        }

    }

    addRequestHeaderToUploader(options: FileUploaderOptions): FileUploaderOptions {
        if (this.depotRequeteState && this.depotRequeteState.version !== undefined) {
            options.headers = [{ name: HEADER_DRAFT_VERSION, value: `${this.depotRequeteState.version}` }];
        }

        return options;
    }

    updateVersionWithResponseHeader(headers: HttpHeaders): number {
        if (headers && headers.get(HEADER_DRAFT_VERSION) && this.depotRequeteState) {
            /* this.depotRequeteState.version = parseInt(headers.get(HEADER_DRAFT_VERSION), 10) + 1; */
        this.depotRequeteState.version = parseInt(headers.get(HEADER_DRAFT_VERSION), 10);
        }
        return this.depotRequeteState ? this.depotRequeteState.version : null;
    }

    updateVersionWithResponseHeaderFromUploader(headers: ParsedResponseHeaders) {
        if (headers && headers[HEADER_DRAFT_VERSION] !== undefined && this.depotRequeteState) {
            /* this.depotRequeteState.version = parseInt(headers[HEADER_DRAFT_VERSION], 10) + 1; */
            this.depotRequeteState.version = parseInt(headers[HEADER_DRAFT_VERSION], 10);
        }
    }

    cleanDepotRequeteState() {
        this.depotRequeteState = null;
    }

    acceptCgu(): Observable<any> {
        if (!this.depotRequeteState) {
            return this.draftRequeteService
                .initMyDraftRequete()
                .pipe(switchMap(draft => this.draftRequeteToDepotRequeteState(draft)));
        }
        return observableOf(this.depotRequeteState);
    }

    saveParties(requeteCategory: RequeteCategory, requerants: PartieDepot[]) {
        if (requeteCategory === RequeteCategory.REQUERANT_SEUL) {
            return this.draftRequeteService.addOneRequerant();
        } else if (requeteCategory === RequeteCategory.COLLECTIVE) {
            return this.draftRequeteService.addRequerants(requerants);
        } else if (requeteCategory === RequeteCategory.AVEC_MANDATAIRE) {
            return this.draftRequeteService.addMandants(requerants);
        }
    }

    saveJuridiction() {
        let juridiction: Juridiction = new Juridiction();

       /*  if (this.depotRequeteState.urgenceRequete !== undefined && this.depotRequeteState.urgenceRequete !== null) {
            juridiction.typeRequeteId = this.depotRequeteState.urgenceRequete.id;
        } */
        if (this.depotRequeteState.typeJuridiction !== undefined && this.depotRequeteState.typeJuridiction !== null) {
            juridiction.typeJuridictionId = this.depotRequeteState.typeJuridiction.id;
        }
        if (this.depotRequeteState.siteJuridiction !== undefined && this.depotRequeteState.siteJuridiction !== null) {
            juridiction.siteJuridictionId = this.depotRequeteState.siteJuridiction.id;
        }
        if (this.depotRequeteState.typeActeAttaque !== undefined && this.depotRequeteState.typeActeAttaque !== null) {
            juridiction.typeActeAttaque = this.depotRequeteState.typeActeAttaque;
        }
        return this.draftRequeteService.addJuridiction(juridiction);
    }

    saveRequeteByEmergencyType(urgenceRequete: UrgenceRequete) {
        console.log('saveRequete | urgenceRequete : ', urgenceRequete);
        if (urgenceRequete && urgenceRequete.codeUrgence === 0) {
            return this.saveNormalProceedingRequest(urgenceRequete);
        } else {
            return this.saveInterimProceedingRequest(urgenceRequete);
        }
    }

    saveNormalProceedingRequest(urgenceRequete: UrgenceRequete) {
        let requeteContentieuxSocial: RequeteContentieuxSocial = new RequeteContentieuxSocial();
        if (urgenceRequete !== undefined && urgenceRequete !== null) {
            requeteContentieuxSocial.typeRequeteId = urgenceRequete.id;
        }
        if (this.depotRequeteState.concernContentieuxSocial !== undefined && this.depotRequeteState.concernContentieuxSocial !== null) {
            requeteContentieuxSocial.contentieuxSocial = this.depotRequeteState.concernContentieuxSocial;
        }
        if (this.depotRequeteState.requeteCS !== undefined && this.depotRequeteState.requeteCS !== null) {
            // if the config is ON
            if (this.depotRequeteState.formActivated) {
                if (requeteContentieuxSocial.contentieuxSocial) {
                    // Sociaux DALO
                    this.buildDALORequete(requeteContentieuxSocial);
                } else {
                    requeteContentieuxSocial.souhait = this.depotRequeteState.requeteCS.souhait;
                    switch (requeteContentieuxSocial.souhait) {
                        case 'Remplir le formulaire : litige lié à une décision de l\'administration':
                            this.buildLitigeLieDecisionAdminRequete(requeteContentieuxSocial);
                            break;
                        case 'Remplir le formulaire : litige lié à une somme d\'argent':
                            requeteContentieuxSocial.typeLitige = this.depotRequeteState.requeteCS.typeLitige;
                            switch (requeteContentieuxSocial.typeLitige) {
                                case 'Vous réclamez une somme d\'argent à l\'administration':
                                    this.buildReclamerUneSommeRequete(requeteContentieuxSocial);
                                    break;
                                case 'Vous contestez une somme d\'argent réclamée par l\'administration':
                                    this.buildContesterUneSommeRequete(requeteContentieuxSocial);
                                    break;
                                case 'Vous réclamez une indemnisation pour une faute commise par l\'administration ou '
                                + 'une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)':
                                    this.buildIndemnisationRequete(requeteContentieuxSocial);
                                    break;
                                default:
                                    this.buildReclamerUneSommeRequete(requeteContentieuxSocial);
                            }
                            break;
                        case 'Déposer une requête que vous avez rédigée':
                            this.buildRequeteDejaRedigee(requeteContentieuxSocial);
                            break;
                        default:
                            this.buildLitigeLieDecisionAdminRequete(requeteContentieuxSocial);
                    }
                }
            } else {
                if (requeteContentieuxSocial.contentieuxSocial) {
                    // Sociaux DALO
                    this.buildDALORequete(requeteContentieuxSocial);
                }
            }
        }
        return this.draftRequeteService.addNormalProceedingRequest(requeteContentieuxSocial);
    }

    private buildDALORequete(requeteContentieuxSocial: RequeteContentieuxSocial) {
        requeteContentieuxSocial.hasDocument = this.depotRequeteState.requeteCS.hasDocument;
        requeteContentieuxSocial.raisonSansDocument = this.depotRequeteState.requeteCS.raisonSansDocument;
        requeteContentieuxSocial.nomsAdministrations = this.depotRequeteState.requeteCS.nomsAdministrations;
        requeteContentieuxSocial.objetDemande = this.depotRequeteState.requeteCS.objetDemande;
        requeteContentieuxSocial.motifs = this.depotRequeteState.requeteCS.motifs;
        requeteContentieuxSocial.conclusionDALO = this.depotRequeteState.requeteCS.conclusionDALO;
        const jointPieces: Array<GenericPiece> = [];
        const pieceRAPO = this.depotRequeteState.piecesComplementaires.find(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.RAPO);
        if (pieceRAPO !== undefined && pieceRAPO !== null) {
            pieceRAPO.libelle = 'RAPO';
            jointPieces.push(pieceRAPO);
        }
        if (this.depotRequeteState.acteAttaquesAFusioner !== undefined &&
            this.depotRequeteState.acteAttaquesAFusioner !== null) {
            jointPieces.push(...this.depotRequeteState.acteAttaquesAFusioner);
        }

        requeteContentieuxSocial.piecesAttachees = jointPieces.map(piece => piece.toDTO());
    }

    private buildLitigeLieDecisionAdminRequete(requeteContentieuxSocial: RequeteContentieuxSocial) {
        requeteContentieuxSocial.hasDocument = this.depotRequeteState.requeteCS.hasDocument;
        requeteContentieuxSocial.raisonSansDocument = this.depotRequeteState.requeteCS.raisonSansDocument;
        requeteContentieuxSocial.nomsAdministrations = this.depotRequeteState.requeteCS.nomsAdministrations;
        requeteContentieuxSocial.objetDemande = this.depotRequeteState.requeteCS.objetDemande;
        requeteContentieuxSocial.contexteInterventionDecision = this.depotRequeteState.requeteCS.contexteInterventionDecision;
        requeteContentieuxSocial.raisonContestations = this.depotRequeteState.requeteCS.raisonContestations;
        requeteContentieuxSocial.conclusionLitigeAdminCheckbox = this.depotRequeteState.requeteCS.conclusionLitigeAdminCheckbox;
        requeteContentieuxSocial.conclusionLitigeAdmin = this.depotRequeteState.requeteCS.conclusionLitigeAdmin;
        const jointPieces: Array<GenericPiece> = [];
        if (this.depotRequeteState.acteAttaquesAFusioner !== undefined &&
            this.depotRequeteState.acteAttaquesAFusioner !== null) {
            jointPieces.push(...this.depotRequeteState.acteAttaquesAFusioner);
        }
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_INTERPRETE).length > 0) {
                if (requeteContentieuxSocial.raisonContestations.some(rc => rc.typeRaisonContestationId === 6)) {
                    jointPieces.push(...this.depotRequeteState.piecesComplementaires.filter(pc =>
                        pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_INTERPRETE));
                } else {
                    this.depotRequeteState.piecesComplementaires =
                    this.depotRequeteState.piecesComplementaires.filter(pc =>
                        pc.complementaryFileOriginType !== PieceComplementaireOrigineType.MAL_INTERPRETE);
                }
        }

        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_APPRECIE).length > 0) {
                if (requeteContentieuxSocial.raisonContestations.some(rc => rc.typeRaisonContestationId === 7)) {
                    jointPieces.push(...this.depotRequeteState.piecesComplementaires.filter(pc =>
                        pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_APPRECIE));
                } else {
                    this.depotRequeteState.piecesComplementaires =
                    this.depotRequeteState.piecesComplementaires.filter(pc =>
                        pc.complementaryFileOriginType !== PieceComplementaireOrigineType.MAL_APPRECIE);
                }
        }

        requeteContentieuxSocial.piecesAttachees = jointPieces.map(piece => piece.toDTO());
    }

    private buildReclamerUneSommeRequete(requeteContentieuxSocial: RequeteContentieuxSocial) {
        requeteContentieuxSocial.nomsAdministrations = this.depotRequeteState.requeteCS.nomsAdministrations;
        requeteContentieuxSocial.objetDemande = this.depotRequeteState.requeteCS.objetDemande;
        requeteContentieuxSocial.contexteInterventionDecision = this.depotRequeteState.requeteCS.contexteInterventionDecision;
        requeteContentieuxSocial.pourquoiSommeDue = this.depotRequeteState.requeteCS.pourquoiSommeDue;
        requeteContentieuxSocial.montantDuMontant = this.depotRequeteState.requeteCS.montantDuMontant;
        requeteContentieuxSocial.conclusionReclamerSommeCondamnerAdmin =
        this.depotRequeteState.requeteCS.conclusionReclamerSommeCondamnerAdmin;
        requeteContentieuxSocial.conclusionReclamerSommeMajoree = this.depotRequeteState.requeteCS.conclusionReclamerSommeMajoree;
        const jointPieces: Array<GenericPiece> = [];
        if (this.depotRequeteState.reclamationPrealablesAFusioner.length > 0) {
            jointPieces.push(...this.depotRequeteState.reclamationPrealablesAFusioner);
        }
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.SOMME_DUE).length > 0) {
                jointPieces.push(...this.depotRequeteState.piecesComplementaires.filter(pc =>
                    pc.complementaryFileOriginType === PieceComplementaireOrigineType.SOMME_DUE));
            }
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MONTANT_DU).length > 0) {
            jointPieces.push(...this.depotRequeteState.piecesComplementaires.filter(pc =>
                pc.complementaryFileOriginType === PieceComplementaireOrigineType.MONTANT_DU));
        }
        requeteContentieuxSocial.piecesAttachees = jointPieces.map(piece => piece.toDTO());
    }

    private buildContesterUneSommeRequete(requeteContentieuxSocial: RequeteContentieuxSocial) {
        const jointPieces: Array<GenericPiece> = [];
        if (this.depotRequeteState.reclamationPrealablesAFusioner.length > 0) {
            jointPieces.push(...this.depotRequeteState.reclamationPrealablesAFusioner);
        }
        requeteContentieuxSocial.nomsAdministrations = this.depotRequeteState.requeteCS.nomsAdministrations;
        requeteContentieuxSocial.objetDemande = this.depotRequeteState.requeteCS.objetDemande;
        requeteContentieuxSocial.faitConduitAuLitige = this.depotRequeteState.requeteCS.faitConduitAuLitige;
        requeteContentieuxSocial.typeActe = this.depotRequeteState.requeteCS.typeActe;
        if (this.depotRequeteState.acteAttaquesAFusioner.length > 0) {
            jointPieces.push(...this.depotRequeteState.acteAttaquesAFusioner);
        }
        if (!requeteContentieuxSocial.typeActe ||
            requeteContentieuxSocial.typeActe === 'Un avis d\'imposition') {
            requeteContentieuxSocial.raisonAvisDimpositionIrreguliers = this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers;
            requeteContentieuxSocial.raisonPasPayerImpot = this.depotRequeteState.requeteCS.raisonPasPayerImpot;
            if (this.depotRequeteState.piecesComplementaires.filter(pc =>
                pc.complementaryFileOriginType === PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE).length > 0) {
                jointPieces.push(...this.depotRequeteState.piecesComplementaires.filter(pc =>
                    pc.complementaryFileOriginType === PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE));
            }
            requeteContentieuxSocial.conclusionAvisImpositionImpot = this.depotRequeteState.requeteCS.conclusionAvisImpositionImpot;
        } else {
            requeteContentieuxSocial.raisonInvalidationTitres = this.depotRequeteState.requeteCS.raisonInvalidationTitres;
            requeteContentieuxSocial.conclusionContesterSommeTitreEmisIrregulierDes =
            this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierDes;
            requeteContentieuxSocial.conclusionContesterSommeTitreEmisIrregulierMontant =
            this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierMontant;
        }
        requeteContentieuxSocial.piecesAttachees = jointPieces.map(piece => piece.toDTO());
    }
    private buildIndemnisationRequete(requeteContentieuxSocial: RequeteContentieuxSocial) {
        console.log('buildIndemnisationRequete');
        requeteContentieuxSocial.nomsAdministrations = this.depotRequeteState.requeteCS.nomsAdministrations;
        requeteContentieuxSocial.objetDemande = this.depotRequeteState.requeteCS.objetDemande;
        requeteContentieuxSocial.faitConduitSituationReparation = this.depotRequeteState.requeteCS.faitConduitSituationReparation;
        requeteContentieuxSocial.prejudiceEvaluableEnArgents = this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents;
        requeteContentieuxSocial.precisionPrejudice = this.depotRequeteState.requeteCS.precisionPrejudice;
        requeteContentieuxSocial.originePrejudice = this.depotRequeteState.requeteCS.originePrejudice;
        requeteContentieuxSocial.conclusionIndemnisationCondamnerAdmin =
        this.depotRequeteState.requeteCS.conclusionIndemnisationCondamnerAdmin;
        requeteContentieuxSocial.conclusionIndemnisationMontant =
        this.depotRequeteState.requeteCS.conclusionIndemnisationMontant;
        requeteContentieuxSocial.conclusionIndemnisationMajoree =
        this.depotRequeteState.requeteCS.conclusionIndemnisationMajoree;
        const jointPieces: Array<GenericPiece> = [];
        if (this.depotRequeteState.reclamationPrealablesAFusioner.length > 0) {
            jointPieces.push(...this.depotRequeteState.reclamationPrealablesAFusioner);
        }
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.PRECISION_PREJUDICE).length > 0) {
                jointPieces.push(...this.depotRequeteState.piecesComplementaires.filter(pc =>
                    pc.complementaryFileOriginType === PieceComplementaireOrigineType.PRECISION_PREJUDICE));
        }
        requeteContentieuxSocial.piecesAttachees = jointPieces.map(piece => piece.toDTO());
    }

    private buildRequeteDejaRedigee(requeteContentieuxSocial: RequeteContentieuxSocial) {
        const jointPieces: Array<GenericPiece> = [];
        if (this.depotRequeteState.acteAttaquesAFusioner !== undefined &&
            this.depotRequeteState.acteAttaquesAFusioner !== null) {
            jointPieces.push(...this.depotRequeteState.acteAttaquesAFusioner);
        }
        if (this.depotRequeteState.reclamationPrealablesAFusioner.length > 0) {
            jointPieces.push(...this.depotRequeteState.reclamationPrealablesAFusioner);
        }
        if (this.depotRequeteState.requete !== undefined && this.depotRequeteState.requete !== null) {
            jointPieces.push(this.depotRequeteState.requete);
        }
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF).length > 0) {
                jointPieces.push(...this.depotRequeteState.piecesComplementaires.filter(pc =>
                pc.complementaryFileOriginType === PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF));
        }
        requeteContentieuxSocial.piecesAttachees = jointPieces.map(piece => piece.toDTO());
    }

    // Référé, à modifier quand le formulaire Référé prend sa forme it_13, it_14
    saveInterimProceedingRequest(urgenceRequete: UrgenceRequete) {
        let typeRequeteId = 3; // valeur temporaire
        if (urgenceRequete !== undefined && urgenceRequete !== null) {
            typeRequeteId = urgenceRequete.id;
        }
        return this.draftRequeteService.addInterimProceedingRequest(typeRequeteId);
    }
    refreshRequete() {
        return this.draftRequeteService.getMyDraftRequeteDetail();
    }

    getContentieuxSocial(contentieuxSocialId: number) {
        return this.draftRequeteService.getContentieuxSocial(contentieuxSocialId);
    }

    saveJustificatifsAndMergeActeAttaquesIfNeeded() {
        let justificatifs: Justificatifs = new Justificatifs();

        this.addPieceJustificatifs(justificatifs);

        return this.draftRequeteService
            .addJustificatifs(justificatifs).pipe(
                map(justifcatifs => {
                    if (justifcatifs) {
                        const acteAttaqueOrReclamationPrealable: Array<FileUploaderModel> = [];
                        if (Array.isArray(justifcatifs) && justifcatifs.some(j => j.fileType === PieceJointType.ACTE_ATTAQUE)) {
                            const acteAttaque = justifcatifs.find(j => j.fileType === PieceJointType.ACTE_ATTAQUE);
                            const fileItem = new FileLikeObject({
                                name: 'Acte attaqué',
                                type: 'application/pdf'
                            });
                            acteAttaqueOrReclamationPrealable.push(new
                                FileUploaderModel(fileItem, acteAttaque['fileApiId'], acteAttaque['fileSize']));
                        }
                        if (Array.isArray(justifcatifs) && justifcatifs.some(j => j.fileType === PieceJointType.RECLAMATION_PREALABLE)) {
                            const reclamationPrealable = justifcatifs.find(j => j.fileType === PieceJointType.RECLAMATION_PREALABLE);
                            const fileItemRP = new FileLikeObject({
                                name: 'Réclamation préalable',
                                type: 'application/pdf'

                            });
                            acteAttaqueOrReclamationPrealable.push(
                                new FileUploaderModel(fileItemRP, reclamationPrealable['fileApiId'], reclamationPrealable['fileSize']));
                        }
                        return acteAttaqueOrReclamationPrealable;
                    } else {
                        return null;
                    }
                })
            )
            ;
    }

    updateStatusToRecapitulatif(): Observable<any> {
        return this.draftRequeteService.addRecapitulatif();
    }

    depotRequete() {
        return this.draftRequeteService.depotRequete().pipe(tap(
            _res => {
                this.alertService.success('home.transfered', null, null);
                this.trackRequete(TrackingAction.SUCCESS);
                this.router.navigate(['/accueil']);
            },
            _res => {
                this.trackRequete(TrackingAction.FAILED);
            }
        ));
    }

    private addPieceJustificatifs(justificatifs: Justificatifs) {
        justificatifs.piecesNotPostales = [
            this.depotRequeteState.requete,
            ...this.depotRequeteState.piecesComplementaires,
            ...this.depotRequeteState.acteAttaquesAFusioner,
            ...this.depotRequeteState.reclamationPrealablesAFusioner,
        ]
            .filter(piece => piece !== null)
            .filter(piece => piece.fileModel) // initialized but not yet uploaded
            .map(piece => piece.toDTO());

        justificatifs.piecesPostales = this.depotRequeteState.piecesPostales.map(piece => piece.toDTO());
    }

    buildUploadUrl() {
        // TODO remove
        return `/api/my-draft-requete/pieces/upload`;
    }

    generateInventairePreview(): Observable<Blob> {
        return this.draftRequeteService.generateInventairePreview();
    }

    downloadJustificatif(fileApiId: string): Observable<Blob> {
        return this.draftRequeteService.downloadJustificatif(fileApiId);
    }

    getMyDraftRequeteDetail(): Observable<DraftRequete> {
        return this.draftRequeteService.getMyDraftRequeteDetail().pipe(tap(draft => {
            if (draft) {
                this.draftRequeteToDepotRequeteState(draft);
            } else {
                this.cleanDepotRequeteState();
            }
        }));
    }

    deleteMyDraftRequete() {
        return this.draftRequeteService.deleteMyDraftRequete().pipe(tap(() => this.cleanDepotRequeteState()));
    }

    getMyDraftRequeteSummary(): Observable<DraftRequeteSummary> {
        return this.draftRequeteService.getMyDraftRequeteSummary().pipe(tap(draftSummary => {
            if (draftSummary) {
                this.draftSummaryToDepotRequeteState(draftSummary);
            } else {
                this.cleanDepotRequeteState();
            }
        }));
    }

    displayDraftModal() {
        this.modalService.open(DraftModalComponent, { size: 'lg' });
    }

    displayOrNotErrorAlertDraft(error: any, showErrorAlertDraft: EventEmitter<any>) {
        if (!this.isDraftConflictError(error)) {
            showErrorAlertDraft.emit();
        }
    }

    private isDraftConflictError(error: any): boolean {
        if (error) {
            const errorBody = error;

            if (error.status === HttpCodeEnum.CONFLICT &&
                errorBody && errorBody.code === ErrorEnum.INVALID_DRAFT_VERSION) {
                return true;
            }
        }

        return false;
    }

    private draftSummaryToDepotRequeteState(draftSummary: DraftRequeteSummary): void {
        if (!this.depotRequeteState) {
            this.depotRequeteState = new DepotRequeteState();
            this.depotRequeteState.id = draftSummary.id;
            this.depotRequeteState.dateCreation = draftSummary.dateCreation;
        }
    }

    /**
     * Return a DepotRequeteState object creating from a DraftRequete object
     * @param draftRequete
     */
    public draftRequeteToDepotRequeteState(draftRequete: DraftRequete): Observable<DepotRequeteState> {
        this.depotRequeteState = new DepotRequeteState();
        this.depotRequeteState.id = draftRequete.id;
        this.depotRequeteState.dateCreation = draftRequete.dateCreation;

        this.depotRequeteState.statut = draftRequete.statut;
        this.depotRequeteState.version = draftRequete.version;

        this.addRequerantFromDrafToDepotRequestState(draftRequete, this.depotRequeteState);
        this.depotRequeteState.concernContentieuxSocial = draftRequete.concernContentieuxSocial;
        this.depotRequeteState.formActivated = draftRequete.formActivated;

        this.parametersService.getParameters().subscribe(parameters => {
            this.juridictions = parameters.juridictions;
            this.typeActeAttaques = parameters.typeActeAttaques;

            this.addJuridictionFromDraft(draftRequete, this.depotRequeteState);
            this.addContentieuxSocialFromDraft(draftRequete, this.depotRequeteState);
            this.addPiecesFromDraft(draftRequete, this.depotRequeteState);
        });

        return observableOf(this.depotRequeteState);
    }

    /**
     * Use to fill the object depotRequeteState from a draftRequete for the Requerant Section
     * @param draftRequete
     * @param depotRequeteState
     */
    private addRequerantFromDrafToDepotRequestState(
        draftRequete: DraftRequete,
        depotRequeteState: DepotRequeteState
    ): void {
        depotRequeteState.requeteCategory = draftRequete.category;
        switch (draftRequete.category) {
            case RequeteCategory.AVEC_MANDATAIRE:
                depotRequeteState.requeteCategory = RequeteCategory.AVEC_MANDATAIRE;
                draftRequete.parties
                    .filter(partie => partie.userId)
                    .forEach(partie => {
                        if (partie.qualite === QualityType.Mandataire) {
                            depotRequeteState.currentActeur = partie;
                        } else if (partie.qualite === QualityType.Requerant) {
                            depotRequeteState.requerants.push(partie);
                        }
                    });
                break;

            case RequeteCategory.COLLECTIVE:
                depotRequeteState.requeteCategory = RequeteCategory.COLLECTIVE;
                draftRequete.parties.forEach(partie => {
                    if (partie.userId !== null) {
                        depotRequeteState.currentActeur = partie;
                    } else {
                        depotRequeteState.requerants.push(partie);
                    }
                });
                break;

            case RequeteCategory.REQUERANT_SEUL:
                depotRequeteState.requeteCategory = RequeteCategory.REQUERANT_SEUL;
                if (draftRequete.parties.length === 1) {
                    if (draftRequete.parties[0].qualite === QualityType.Requerant) {
                        depotRequeteState.currentActeur = draftRequete.parties[0];
                    }
                }
                break;
        }
    }

    /**
     * Use to fill the object depotRequeteState from a draftRequete for the Juridiction Section
     * @param draftRequete
     * @param depotRequeteState
     */
    private addJuridictionFromDraft(draftRequete: DraftRequete, depotRequeteState: DepotRequeteState) {
        depotRequeteState.typeJuridiction =
            draftRequete.typeJuridictionId != null
                ? this.juridictions.find(juridiction => juridiction.id === draftRequete.typeJuridictionId)
                : null;

        depotRequeteState.siteJuridiction =
            depotRequeteState.typeJuridiction != null && draftRequete.siteJuridictionId != null
                ? depotRequeteState.typeJuridiction.siteJuridictions.find(
                      sj => sj.id === draftRequete.siteJuridictionId
                  )
                : null;

        depotRequeteState.urgenceRequete =
            draftRequete.typeRequeteId != null && depotRequeteState.typeJuridiction != null
                ? depotRequeteState.typeJuridiction.urgencesRequete.find(
                      urgenceRequete => urgenceRequete.id === draftRequete.typeRequeteId
                  )
                : null;

        depotRequeteState.typeActeAttaque =
            draftRequete.typeActeAttaque != null && depotRequeteState.siteJuridiction != null
                ? draftRequete.typeActeAttaque.code
                : null;
    }

    private addContentieuxSocialFromDraft(draftRequete: DraftRequete, depotRequeteState: DepotRequeteState) {
        depotRequeteState.requeteCS = null;
        if (draftRequete.contentieuxSocialId != null) {
            this.getContentieuxSocial(draftRequete.contentieuxSocialId).subscribe(cs => depotRequeteState.requeteCS = cs);
        }
        if (draftRequete.pieces.length > 0) {
            draftRequete.pieces.forEach(piece => {
                let file = { name: piece.fileName, type: piece.fileType, size: piece.fileSize };
                let fileLikeObject = new FileLikeObject(file);
                let fileModel = new FileUploaderModel(fileLikeObject, piece.fileApiId, piece.fileSize);
                if (piece.fileType === PieceJointType.REQUETE) {
                    let pieceRequete = new PieceRequete(fileModel);
                    depotRequeteState.requete = pieceRequete;
                }
            });
        }
    }

    /**
     * Use to fill the object depotRequeteState from a draftRequete for the PieceJointe Section
     * @param draftRequete
     * @param depotRequeteState
     */
    private addPiecesFromDraft(draftRequete: DraftRequete, depotRequeteState: DepotRequeteState) {
        draftRequete.pieces.forEach(piece => {
            let file = { name: piece.fileName, type: piece.fileType, size: piece.fileSize };
            let fileLikeObject = new FileLikeObject(file);
            let fileModel = new FileUploaderModel(fileLikeObject, piece.fileApiId, piece.fileSize);
            switch (piece.fileType) {
                case PieceJointType.REQUETE:
                    let pieceRequete = new PieceRequete(fileModel);
                    depotRequeteState.requete = pieceRequete;
                    break;
                case PieceJointType.ACTE_ATTAQUE:
                    let pieceActeAttaque = new PieceActeAttaque(fileModel);

                    if (piece.createdFromHash) {
                        depotRequeteState.acteAttaque = pieceActeAttaque;
                    } else {
                        if (depotRequeteState.acteAttaque.fileModel == null) {
                            depotRequeteState.acteAttaque = pieceActeAttaque;
                        }

                        depotRequeteState.acteAttaquesAFusioner.push(pieceActeAttaque);
                    }
                    break;
                case PieceJointType.RECLAMATION_PREALABLE:
                    let pieceReclamationPrealable = new PieceReclamationPrealable(fileModel);

                    if (piece.createdFromHash) {
                        depotRequeteState.reclamationPrealable = pieceReclamationPrealable;
                    } else {
                        if (depotRequeteState.reclamationPrealable.fileModel == null) {
                            depotRequeteState.reclamationPrealable = pieceReclamationPrealable;
                        }

                        depotRequeteState.reclamationPrealablesAFusioner.push(pieceReclamationPrealable);
                    }
                    break;
                case PieceJointType.PIECE_JOINTE_REQUETE:
                    let pieceComplementaire =
                    new PieceComplementaire(fileModel, PieceJointType.PIECE_JOINTE_REQUETE, PieceComplementaireOrigineType.DEFAULT);
                    // update piece complementaire origin type
                    pieceComplementaire.complementaryFileOriginType = piece.complementaryFileOriginType;
                    pieceComplementaire.libelle = piece.libelle;
                    depotRequeteState.piecesComplementaires.push(pieceComplementaire);
                    break;
                case PieceJointType.PIECE_POSTALE:
                    if (!depotRequeteState.piecesPostales.some(pp => pp.libelle === piece.libelle)) {
                        let piecePostale = new PiecePostale(piece.libelle);
                        depotRequeteState.piecesPostales.push(piecePostale);
                    }
                    break;
            }
        });
    }

    public refreshPiecesFromDraft(draftRequete: DraftRequete, depotRequeteState: DepotRequeteState) {
        // remove all piece from depotRequeteState
        depotRequeteState.requete = null!;
        depotRequeteState.acteAttaque = null!;
        depotRequeteState.acteAttaquesAFusioner.length = 0;
        depotRequeteState.reclamationPrealable = null!;
        depotRequeteState.reclamationPrealablesAFusioner.length = 0;
        depotRequeteState.piecesComplementaires.length = 0;

        draftRequete.pieces.forEach(piece => {
            let file = { name: piece.fileName, type: piece.fileType, size: piece.fileSize };
            let fileLikeObject = new FileLikeObject(file);
            let fileModel = new FileUploaderModel(fileLikeObject, piece.fileApiId, piece.fileSize);
            switch (piece.fileType) {
                case PieceJointType.REQUETE:
                    let pieceRequete = new PieceRequete(fileModel);
                    depotRequeteState.requete = pieceRequete;
                    break;
                case PieceJointType.ACTE_ATTAQUE:
                    let pieceActeAttaque = new PieceActeAttaque(fileModel);

                    if (piece.createdFromHash) {
                        depotRequeteState.acteAttaque = pieceActeAttaque;
                    } else {
                        if (depotRequeteState.acteAttaque && depotRequeteState.acteAttaque.fileModel == null) {
                            depotRequeteState.acteAttaque = pieceActeAttaque;
                        }

                        depotRequeteState.acteAttaquesAFusioner.push(pieceActeAttaque);
                    }
                    break;
                case PieceJointType.RECLAMATION_PREALABLE:
                    let pieceReclamationPrealable = new PieceReclamationPrealable(fileModel);

                    if (piece.createdFromHash) {
                        depotRequeteState.reclamationPrealable = pieceReclamationPrealable;
                    } else {
                        if (depotRequeteState.reclamationPrealable && depotRequeteState.reclamationPrealable.fileModel == null) {
                            depotRequeteState.reclamationPrealable = pieceReclamationPrealable;
                        }

                        depotRequeteState.reclamationPrealablesAFusioner.push(pieceReclamationPrealable);
                    }
                    break;
                case PieceJointType.PIECE_JOINTE_REQUETE:
                    let pieceComplementaire =
                    new PieceComplementaire(fileModel, PieceJointType.PIECE_JOINTE_REQUETE, PieceComplementaireOrigineType.DEFAULT);
                    // update piece complementaire origin type
                    pieceComplementaire.complementaryFileOriginType = piece.complementaryFileOriginType;
                    pieceComplementaire.libelle = piece.libelle;
                    depotRequeteState.piecesComplementaires.push(pieceComplementaire);
                    break;
                case PieceJointType.PIECE_POSTALE:
                    if (!depotRequeteState.piecesPostales.some(pp => pp.libelle === piece.libelle)) {
                        let piecePostale = new PiecePostale(piece.libelle);
                        depotRequeteState.piecesPostales.push(piecePostale);
                    }
                    break;
            }
        });
    }

    trackInventairePreviewDownload() {
        this.trackingService.trackEvent({
            action: TrackingAction.DOWNLOAD,
            properties: {
                category: TrackingCategory.DEPOT_REQUETE,
                name: TrackingName.PREVIEW_INVENTORY
            }
        });
    }

    trackInventairePreviewFail() {
        this.trackingService.trackEvent({
            action: TrackingAction.DOWNLOAD_FAILED,
            properties: {
                category: TrackingCategory.DEPOT_REQUETE,
                name: TrackingName.PREVIEW_INVENTORY
            }
        });
    }

    private trackRequete(action: TrackingAction): void {
        let requete = this.depotRequeteState;

        this.trackingService.trackEvent({
            action,
            properties: {
                category: TrackingCategory.DEPOT_REQUETE,
                name: TrackingName.GENERAL
            }
        });
        this.trackingService.trackEvent({
            action,
            properties: {
                category: TrackingCategory.DEPOT_REQUETE_COMPTE,
                name: requete.currentActeur.type === AccountType.PHYSIQUE ? 'Personne physique' : 'Personne morale'
            }
        });
        this.trackingService.trackEvent({
            action,
            properties: {
                category: TrackingCategory.DEPOT_REQUETE_TYPE,
                name: requete.requeteCategory
            }
        });
        this.trackingService.trackEvent({
            action,
            properties: {
                category: TrackingCategory.DEPOT_REQUETE_TYPE_JURIDICTION,
                name: requete.typeJuridiction.code
            }
        });
        this.trackingService.trackEvent({
            action,
            properties: {
                category: TrackingCategory.DEPOT_REQUETE_SITE_JURIDICTION,
                name: requete.siteJuridiction.code
            }
        });
       /*  this.trackingService.trackEvent({
            action,
            properties: {
                category: TrackingCategory.DEPOT_REQUETE_URGENCE,
                name: requete.urgenceRequete.libelle
            }
        }); */

        if (requete.piecesComplementaires.length) {
            this.trackingService.trackEvent({
                action,
                properties: {
                    category: TrackingCategory.DEPOT_REQUETE,
                    name: TrackingName.NOMBRE_PIECES_COMPLEMENTAIRES,
                    value: requete.piecesComplementaires.length
                }
            });
        }

        if (requete.piecesPostales.length) {
            this.trackingService.trackEvent({
                action,
                properties: {
                    category: TrackingCategory.DEPOT_REQUETE,
                    name: TrackingName.NOMBRE_PIECES_POSTALES,
                    value: requete.piecesPostales.length
                }
            });
        }

        if (requete.requeteCategory === RequeteCategory.AVEC_MANDATAIRE) {
            this.trackingService.trackEvent({
                action,
                properties: {
                    category: TrackingCategory.DEPOT_REQUETE,
                    name: TrackingName.NOMBRE_MANDANTS,
                    value: requete.requerants.length
                }
            });
        }

        if (requete.requeteCategory === RequeteCategory.COLLECTIVE) {
            this.trackingService.trackEvent({
                action,
                properties: {
                    category: TrackingCategory.DEPOT_REQUETE,
                    name: TrackingName.NOMBRE_REQUERANTS_REQUETE_COLLECTIVE,
                    value: requete.requerants.length
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/draft-depot-requete.service.ts